/**
 * Switch between development and production APIs for this module
 * by swapping comments on the corresponding lines.
 */

// import productApi from './dev';  // dev
import voucherApi from './prod'; // prod

export default voucherApi;
